import React, { PureComponent } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import axios from "axios";
import SearchBusinesses from "../SearchBusinesses";

const INITIAL_STATE = {
  selectedRole: null,
  isInviting: false,
  business: null,
  error: null,
  businesses: []
};

class BusinessRoleModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = INITIAL_STATE;
    this.onRoleSelect = this.onRoleSelect.bind(this);
    this.onBusinessSelect = this.onBusinessSelect.bind(this);
    this.close = this.close.bind(this);
    this.switchPermission = this.switchPermission.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.user && this.props.user) {
      this.setState({ businesses: this.gatherBusinesses() }, () => {
        console.log(this.state.businesses);
      });
    }
  }

  onBusinessSelect(e) {
    this.setState({ business: this.state.businesses[e.target.value] }, () => {
      console.log(this.state.business);
    });
  }

  onRoleSelect(e) {
    this.setState({ selectedRole: e.target.value });
  }

  switchPermission() {
    const token = sessionStorage.getItem("token");
    this.setState({ isInviting: true, error: null });
    const payload = {
      name: this.state.selectedRole,
      entityId: this.state.business.entity.id
    };

    const headers = { Authorization: `Bearer ${token}` };
    axios
      .put(
        `/api/proxy/v2/users/${this.props.user.id}/permisgroups/switch`,
        payload,
        { headers }
      )
      .then(() => {
        this.setState({
          isInviting: false,
          selectedRole: null,
          business: null
        });
        this.props.onSuccess();
      })
      .catch(err => {
        this.setState({ error: err.response.data.error });
        this.setState({ isInviting: false });
        if (this.props.onCompletion) {
          this.props.onCompletion();
        }
      });
  }

  close() {
    this.props.close();
    this.setState({ ...INITIAL_STATE });
  }

  gatherBusinesses() {
    return Object.keys(this.props.user.privyData.group.businesses)
      .map(role =>
        this.props.user.privyData.group.businesses[role].map(
          business => business
        )
      )
      .reduce((acc, val) => acc.concat(val), []);
  }

  render() {
    return this.props.user ? (
      <Modal
        isOpen={this.props.open}
        toggle={this.toggle}
        className={this.props.className}
      >
        <ModalHeader toggle={this.close}>Manage Role</ModalHeader>
        <ModalBody>
          <FormGroup>
            {this.state.error && (
              <p style={{ color: "red", marginBottom: 0 }}>
                {this.state.error}
              </p>
            )}
            <Label>Select a Business</Label>
            <Input
              type="select"
              className="form-control"
              onChange={this.onBusinessSelect}
            >
              <option
                selected={this.state.selectedRole === null}
                default
                value={null}
              >
                Select a Business
              </option>
              {this.state.businesses.map((business, idx) => {
                return (
                  <option key={business.entity.id} value={idx}>
                    {business.entity.name}
                  </option>
                );
              })}
            </Input>
          </FormGroup>
          {this.state.business ? (
            <FormGroup>
              <Label>Modify Role</Label>
              <Input
                type="select"
                className="form-control"
                onChange={this.onRoleSelect}
              >
                <option
                  selected={this.state.selectedRole === null}
                  default
                  value={null}
                >
                  Select a Role
                </option>
                <option value="BusinessManager">Manager</option>
                <option value="BusinessOwner">Owner</option>
              </Input>
            </FormGroup>
          ) : null}
        </ModalBody>
        <ModalFooter>
          <Button
            disabled={!this.state.business || !this.state.selectedRole}
            color="primary"
            onClick={this.switchPermission}
          >
            {this.state.isInviting && (
              <i
                className="fa fa-circle-o-notch fa-spin"
                style={{ marginRight: 5 }}
              />
            )}
            Submit
          </Button>{" "}
          <Button color="secondary" onClick={this.toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    ) : null;
  }
}

export default BusinessRoleModal;



// WEBPACK FOOTER //
// ./src/views/Pages/Users/BusinessRoleModal.js